import { decode } from 'jsonwebtoken';
import { getEnv } from './utils/getEnv';


export const retrieveLoginURI = _ => {
  const env = getEnv();
  if(env === 'local') return 'http://localhost:4000/login';
  if(env === 'staging') return 'https://graphql.staging.matrak.com.au/login';
  if(env === 'sandbox') return 'https://rest-sandbox.matrak.com.au/private/login';
  if(env === 'prod') return 'https://graphql.matrak.com.au/login';
  if(env === 'feature') return 'https://rest-feature.matrak.com.au/private/login';
}

const URI = retrieveLoginURI();

const authProvider = {
  login: ({ username, password }) => fetch(URI, {
    method: 'POST',
    body: JSON.stringify({ username, password }),
    headers: new Headers({ 'Content-Type': 'application/json' }),
  })
    .then((res) => {
      if (res.status < 200 || res.status >= 300) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        throw new Error(res.statusText);
      }
      return res.json();
    })
    .then((data) => {
      const { token } = data;
      const tokenPayload = decode(token);
      if(!tokenPayload) {
        return;
      }
      if (!tokenPayload.superUser) {
        return;
      }
      const user = {
        userId: tokenPayload.userId,
        username,
      };
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', token);
    }),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return Promise.resolve();
  },
  checkError: ({ status, graphQLErrors}) => {
    // Logout user if token is expired
    if (graphQLErrors && graphQLErrors[0].message === 'Unauthorized') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return Promise.reject();
    }

    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    return localStorage.getItem('token')
      ? Promise.resolve()
      : Promise.reject();
  },
  getPermissions: () => Promise.resolve(),
};

window.setInterval(() => {
  const user = localStorage.getItem('user');
  if(!user) {
    window.location.href = '/#/Login';
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
  const token = localStorage.getItem('token');
  const { exp } = decode(token) || {};
  if(!exp || (Date.now() >= exp * 1000)) {
    window.location.href = '/#/Login';
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}, 1000)

export default authProvider;
